module.exports = __webpack_public_path__ + "img/image00001.1643fa20.jpeg";